import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Payment from '../Payment/Payment';
import { getPage, hasError } from '../../../states/page/selectors';
import { pages } from '../../../states/page/actions';
import Review from '../Review/Review';
import { Submitted } from '../Submitted/Submitted';

const mapState = (state) => ({
	page: getPage(state),
	hasError: hasError(state),
});

class LayoutContainer extends Component {
	componentDidUpdate() {
		const { hasError, handleRoute } = this.props;

		if (hasError) handleRoute('WEB-ERROR');
	}

	renderPage() {
		const { page } = this.props;
		switch (page) {
			case pages.RetailPayment:
				return <Payment />;
			case pages.RetailReview:
				return <Review />;
			case pages.RetailSubmitted:
				return <Submitted />;
			default:
				return null;
		}
	}

	render() {
		return <div>{this.renderPage()}</div>;
	}
}

LayoutContainer.propTypes = {
	page: PropTypes.string.isRequired,
	hasError: PropTypes.bool,
	handleRoute: PropTypes.func,
};

export default connect(mapState)(LayoutContainer);
